import React from 'react';
import './galleryFilter.css';

const GalleryFilter = ({ categories, activeCategory, onCategoryChange }) => {
	return (
		<div className="gallery-filter">
			<div className="gallery-filter-buttons">
				{categories.map((category) => (
					<button
						key={category}
						type="button"
						className={`gallery-filter-btn ${activeCategory === category ? 'active' : ''}`}
						onClick={() => {
							onCategoryChange(category);
						}}
					>
						{category.charAt(0).toUpperCase() + category.slice(1)}
					</button>
				))}
			</div>
		</div>
	);
};

export default GalleryFilter;
